import React, { useState } from "react";
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import GalleryImage from "./galleryImage.jsx";

// make modal sit over the navbar
const customModalStyle = {
  overlay: {zIndex: 9000}
};

export default function Gallery({gallery, categories}) {

  const [filter, setFilter] = useState(categories[0].filter);
  
  // Light Gallery Modal
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setOpen] = useState(false);

  const filterChangeHandler = (e) => {
    setFilter(e.target.id);
  }

  const galleryClickHandler = (index) => {
    setOpen(true);
    setPhotoIndex(index);
  }

  const images = gallery.filter(item => item.filter === filter);
  
  return (
      <React.Fragment>
        <Row>
          <Col>
            <ButtonGroup className="d-flex" aria-label="Gallery filter button group">
            {
              categories.map((item, i) => (
                <Button className={item.filter === filter ? 'active' : null } variant="secondary" key={"buttonFilter_" + i} id={item.filter} onClick={ filterChangeHandler }>{item.title}</Button>
              ))
            }
            </ButtonGroup>
          </Col>
        </Row>
        <Row className="mt-4">
        {
          images.map((image, i) => (
            <Col key={"picture_" + i} xs={6} sm={6} md={3} lg={2} xl={2} className="my-auto pb-4 overflow-hidden">
              <GalleryImage index={i} src={ getImageSrc(image) } title={image.title} onClickHandler={ galleryClickHandler } />
            </Col>
          ))
        }
        </Row>

        {isOpen && (
          <Lightbox
            reactModalStyle={customModalStyle}
            mainSrc={ getImageSrc(images[photoIndex]) }
            nextSrc={ getImageSrc(images[getNextPhotoIndex(photoIndex)]) }
            prevSrc={ getImageSrc(images[getPrevPhotoIndex(photoIndex)]) }
            onCloseRequest={ () => setOpen(false) }
            onMovePrevRequest={ () => setPhotoIndex(getPrevPhotoIndex(photoIndex)) }
            onMoveNextRequest={ () => setPhotoIndex(getNextPhotoIndex(photoIndex)) }
          />
        )}

      </React.Fragment>
  );

  function getImageSrc(imageItem) {
    return "/images/gallery/" + imageItem.filename;
  }

  function getNextPhotoIndex(currIndex) {
    return (currIndex + 1) % images.length;
  }

  function getPrevPhotoIndex(currIndex) {
    return (currIndex - 1 + images.length) % images.length;
  }
}
